export default "__VITE_ASSET__D8a9OSqj__"